import { YouTubePlaylistItem } from './types'
import { useMemo, useContext } from 'external/react'
import {TeacherContext} from 'teacher/context'

type VideoContainerProps = {
  video: YouTubePlaylistItem,
  setActiveVideo: any
}

type VideoGridContainerProps = {
  searchCriteria: string | null
}

export const VideoGridContainer = ({ searchCriteria }: VideoGridContainerProps) => {
  
  const {dashboard, updateState} = useContext(TeacherContext) as any
  const activeVideo = useMemo(() => dashboard.activeVideo as YouTubePlaylistItem | null, [dashboard.activeVideo])
  const videos = useMemo(() => dashboard.videos as YouTubePlaylistItem[], [dashboard.videos])
  const setActiveVideo = useMemo(() => (video:any) => updateState({dashboard: {activeVideo: {$set: video}}}), [])
  
  return (
    <div className='carousel-grid-container'>
      {videos?.filter((video) => (!searchCriteria || video.snippet.title.toLowerCase().includes(searchCriteria))).map((video) => (
        <VideoContainer key={video.id} video={video} setActiveVideo={setActiveVideo}/>
      ))}
      {activeVideo && (
        <div className="modal-overlay" onClick={() => setActiveVideo(null)}>
          <div
            className="modal-content"
            onClick={e => e.stopPropagation()}
          >
            <button
              className="close-button"
              onClick={() => setActiveVideo(null)}
            >
              ✕
            </button>

            <iframe
              src={`https://www.youtube.com/embed/${activeVideo.snippet.resourceId.videoId}?autoplay=1`}
              title={activeVideo.snippet.title}
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
            <h3>{activeVideo.snippet.title}</h3>
          </div>
        </div>
      )}
    </div>
  )
}

const VideoContainer = ({ video, setActiveVideo }: VideoContainerProps) => {
  const thumbnail = video.snippet.thumbnails.maxres ?? video.snippet.thumbnails.high
  return (
    <div
      key={video.id}
      className="carousel-item"
      onClick={() => setActiveVideo(video)}
    >
      <img src={thumbnail?.url} alt={video.snippet.title} />
      <p className='video-title'>{video.snippet.title}</p>
      <p className='video-description'>{video.snippet.description.split(' ').slice(0, 10).join(' ').concat('...')}</p>
    </div>
  )
}